<template>
  <div id="withdraw-modal" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h2
            class="font-medium text-base"
            :class="isRTL ? 'ml-auto' : 'mr-auto'"
          >
            <app-i18n code="wallets.withdraw"></app-i18n>
          </h2>
        </div>
        <div>
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-8">
            <div class="col-span-12">
              <label for="withdrawAmount" class="form-label">{{
                i18n('wallets.withdrawAmount')
              }}</label>
              <input
                id="withdrawAmount"
                v-model="amount"
                type="number"
                class="form-control w-full"
              />
            </div>
            <div class="col-span-12">
              <label for="transactionNumber" class="form-label">{{
                i18n('wallets.transactionNumber')
              }}</label>
              <input
                id="transactionNumber"
                v-model="transactionNumber"
                type="text"
                class="form-control w-full"
              />
            </div>
          </div>
          <div class="modal-footer flex justify-center items-center gap-2">
            <AppButton
              id="submit-btn"
              type="button"
              data-dismiss="modal"
              class="btn bg-theme-36 text-white cursor-pointer"
              :class="!withdrawLoading ? 'w-28' : ''"
              :disabled="withdrawLoading"
              :loading="withdrawLoading"
              @click="doSubmit"
            >
              <strong>{{ i18n('wallets.withdraw') }}</strong>
              <template v-slot:loading>
                <span>{{ i18n('common.loading') }}</span>
                <LoadingIcon
                  icon="three-dots"
                  color="#FFFFFF"
                  style="margin: 0 4px"
                />
              </template>
            </AppButton>
            <button
              type="button"
              data-dismiss="modal"
              class="btn bg-theme-31 text-black w-24"
            >
              {{ i18n(`common.cancel`) }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Message from '@/shared/message/toastify'

export default {
  name: 'app-withdraw-modal',
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      amount: undefined,
      transactionNumber: undefined
    }
  },
  computed: {
    ...mapGetters({
      isRTL: 'layout/isRTL',
      withdrawLoading: 'user/view/withdrawLoading'
    })
  },
  methods: {
    ...mapActions({
      doWithdraw: 'user/view/doWithdraw'
    }),
    i18n(key, args) {
      return this.$t(key, args)
    },
    async doSubmit() {
      if (!this.amount || this.amount <= 0) {
        Message.error(
          this.isRTL ? 'ادخل قيمه السحب' : 'enter the withdraw amount'
        )
        return false
      }
      if (!this.transactionNumber || this.transactionNumber.length === 0) {
        Message.error(
          this.isRTL ? 'ادخل رقم التحويلة' : 'enter the transaction Number'
        )
        return false
      }
      if (!/^[0-9]*\.?[0-9]+$/.test(this.amount)) {
        Message.error(this.isRTL ? 'أدخل رقمًا صالحًا' : 'enter a valid number')
        return false
      }
      await this.doWithdraw({
        amount: parseFloat(this.amount),
        transactionNumber: this.transactionNumber
      })
      this.amount = undefined
      this.transactionNumber = undefined
      cash('#withdraw-modal').modal('hide')
    }
  }
}
</script>
